module.exports = __webpack_public_path__ + "img/logo1 (24).8af4cbfd.jpg";